import { SharedSlice } from 'src/components/slice'
import { StateCreator } from 'zustand'
import { Invoice } from '$models'
import { invoiceService } from '$services'
import { exceptionMessageHandler } from '$utils'
import { StockFile } from '@loadedhub/loaded-stock-api-sdk'
import { Dayjs } from 'dayjs'

interface InvoicesState {
  invoices: Invoice[]
  unclassifiedFiles: StockFile[]
}

export interface InvoicesSlice extends InvoicesState {
  /**
   * Resets the Invoice Slice state
   */
  resetInvoicesSlice: () => void

  /**
   * Get invoices list
   */
  getInvoices(
    start?: Dayjs,
    end?: Dayjs,
    invoiceNumber?: string,
    supplierName?: string
  ): Promise<void>

  /**
   * Get unclassified files
   */
  getUnclassifiedFiles: () => Promise<void>
  // DO NOT REMOVE: This will be implemented in a later Epic
  // /**
  //  * Add invoice
  //  * @param errorMessage the message to display if the request fails
  //  * @param successMessage the message to display if the request is sucessful
  //  */
  // addInvoice: (
  //   errorMessage?: string,
  //   successMessage?: string
  // ) => Promise<void>
}

const initialState: InvoicesState = {
  invoices: [],
  unclassifiedFiles: [],
}

const createInvoicesSlice: StateCreator<
  InvoicesSlice & SharedSlice,
  [],
  [],
  InvoicesSlice
> = (set) => ({
  // State variables
  ...initialState,

  // State setters
  resetInvoicesSlice: () => set(initialState),

  // State API calls
  getInvoices: async (
    start?: Dayjs,
    end?: Dayjs,
    invoiceNumber?: string,
    supplierName?: string
  ): Promise<void> => {
    try {
      set(() => ({ isLoading: true }))
      const result = await invoiceService.getInvoices(
        start,
        end,
        invoiceNumber,
        supplierName
      )
      set(() => ({
        invoices: result,
      }))
    } catch (error) {
      set(() => ({
        invoices: [],
      }))
      exceptionMessageHandler(error, 'Failed to retrieve incoming invoices')
    } finally {
      set(() => ({ isLoading: false }))
    }
  },

  getUnclassifiedFiles: async (): Promise<void> => {
    return invoiceService
      .getUnclassifiedFiles()
      .then((result) => {
        set(() => ({
          unclassifiedFiles: result,
        }))
      })
      .catch((error) => {
        set(() => ({
          unclassifiedFiles: [],
        }))
        exceptionMessageHandler(error, 'Failed to retrieve unclassified files')
      })
  },

  // DO NOT REMOVE: This will be implemented in a later Epic
  // addInvoice: async (
  //   errorMessage?: string,
  //   successMessage?: string
  // ): Promise<void> => {
  //   try {
  //     set(() => ({ isLoading: true }))

  //     const newInvoice = await stockService.addInvoice({})

  //     if (!newInvoice) {
  //       logger.error(`${errorMessage} - Failed to create a new invoice`);

  //       enqueueLoadedSnackbar(errorMessage, 'error')
  //       return
  //     }

  //     set((state) => ({
  //       // invoices: [...state.invoices, newInvoice]
  //     }))
  //     enqueueLoadedSnackbar(successMessage, 'success')
  //   } catch (error) {
  //     exceptionMessageHandler(error, errorMessage)
  //   } finally {
  //     set(() => ({ isLoading: false }))
  //   }
  // }
})

export default createInvoicesSlice
